import { render } from "./SettingProfile.vue?vue&type=template&id=827aa7e2"
import script from "./SettingProfile.vue?vue&type=script&lang=js"
export * from "./SettingProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__